<template>
    <div class="services">
        <b-container fluid>
            <b-row>
                <b-col md="11" offset-md="1" class="title-container">
                    <h1 class="red">Our Services</h1>
                </b-col>
            </b-row> 
        </b-container>
        <b-container fluid class="text-container">
            <b-row>
                <b-col md="5" offset-md="1" class="centerv mb-5">
                    <h2>Consulting</h2>
                    <p>No matter how complex your project is, or how complicated it is to carry it out, with the support of our experts and our network of distributors we will support you throughout the process.</p>
                </b-col>
                <b-col md="6" class="mb-5">
                    <img src="../assets/img/img_services_consulting.jpg" class="img-fluid" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5" offset-md="1" class="centerv mb-5">
                    <h2>Design of Spaces</h2>
                    <p>Through the creation of plans and detailed study of spaces, we will make sure that your kitchen is a highly efficient place with great attention to detail and the needs of your company.</p>
                </b-col>
                <b-col md="6" class="mb-5">
                    <img src="../assets/img/img_services_design.jpg" class="img-fluid" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5" offset-md="1" class="centerv mb-5">
                    <h2>Technical Service</h2>
                    <p>Provinco's technical service will help you maintain the functionality of your kitchen through professional and quality maintenance, which our trained technicians will be happy to provide. We currently provide this service only in Mexico.</p>
                </b-col>
                <b-col md="6" class="mb-5">
                    <img src="../assets/img/img_services_technical.jpg" class="img-fluid" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5" offset-md="1" class="centerv mb-5">
                    <h2>Equipment Sales</h2>
                    <p>Committed to providing quality service to our customers through our products, at Provinco we strive to offer the leading brands in the market and a guarantee of quality, thus ensuring the confidence of having equipment at the forefront of new technologies on the market.</p>
                </b-col>
                <b-col md="6" class="mb-5">
                    <img src="../assets/img/img_services_equipment.jpg" class="img-fluid" alt="">
                </b-col>
            </b-row>
            <div class="background-gray"></div>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.services{
    padding: 10% 0;
}
.text-container{
    padding: 30px 5% 0 5%;
    position: relative;
}
.title-container{
    padding: 0 4%;
}
.background-gray{
    background: #E5E5E5;
    height: 100%;
    width: 30%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
}
h2{
    font-size: 50px;
}

@media (max-width: 1600px){
    h1{
        font-size: 45px;
    }
}

@media (max-width: 768px){
    h1{
        font-size: 35px;
    }
    .background-gray{
        display: none;
    }
    .services{
        padding: 15% 0;
    }
}
</style>